<template>
  <div class="max-w-625 mt-50 md:mt-90 mx-auto text-left">
    <StepContent :theme="theme">
      <div class="sorry">
        <h3 class="text-3xl">
          {{ title }}
        </h3>
        <div class="sorry-subheader">
          Let's pave the way to approval.
        </div>
        <p v-if="displaySorry">
          {{ sorryMessage }}
        </p>
        <div v-else>
          <p>
            We understand that receiving a decline notification can be disheartening, and we want to assure you that we value your relationship with us.
            While your application was not approved this time, we would like to provide you with some guidance on how you can improve your credit score and increase your chances of a successful application in the future.
          </p>
          <p>
            By following these steps, you can gradually improve your credit score over time.
            Once you have made progress in these areas, we encourage you to reapply for a personal loan with us after a <b>minimum period of 30 days.</b>
          </p>
        </div>

        <div

          class="sorry-list"
        >
          <div
            v-for="(item, index) in sorryList"
            :key="index"
            class="sorry-list-item"
          >
            <div class="sorry-list-item__icon">
              <img
                :src="item.img"
                :alt="item.imgAlt"
              >
            </div>
            <!-- eslint-disable vue/no-v-html -->
            <div
              class="flex-1"
              v-html="item.content"
            />
            <!-- eslint-enable vue/no-v-html -->
          </div>

          <p>
            Please note that every application is assessed on a case-by-case basis, taking into account various factors.
            We cannot guarantee approval, but we remain committed to assisting you throughout this process.
          </p>

          <p>
            If you have any questions or require further assistance, please do not hesitate to
            <a
              class="underline cursor-pointer text-blue-500"
              @click="triggerChat"
            > chat with us</a>.

            We are here to support you on your journey toward financial well-being.
          </p>
          <p>
            Thank you for choosing Spring Financial. We appreciate the opportunity to assist you and look forward to the possibility of working together in the future.
          </p>
        </div>
        <FreshChat
          :load-chat="loadChat"
          @close-chat="loadChat = false"
        />
      </div>
    </StepContent>
  </div>
</template>

<script>
import StepContent from '@/components/common/step-layout/StepContent'
import DataLayer from '@/utilities/data-layer'
import theme from '@/mixins/theme'
import FreshChat from '@/components/widgets/freshchat/FreshChat'
import chatHandler from '@/mixins/freshchat/chat-handler'

export default {
  name: 'Sorry',

  // Components
  components: {
    StepContent,
    FreshChat
  },

  // Mixins
  mixins: [theme, chatHandler],

  // Props
  props: {
    title: {
      type: String,
      default: `We couldn't approve your loan`
    },

    sorryMessage: {
      type: String,
      default: ''
    },

    displaySorry: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      loadChat: {
        type: Boolean,
        default: false
      },
      sorryList: [
        {
          img: require('@/assets/svg/sorry/review_credit.svg'),
          imgAlt: 'Review your credit report',
          content: 'Review your credit report: Obtain a copy of your credit report from a reputable credit reporting agency. Carefully examine the report for any errors, inaccuracies, or fraudulent activities. We have partnered with <a class="underline text-blue-500" href="https://spgfl.ca/Twxb">Borrowell to offer you a free credit report</a>.'
        },

        {
          img: require('@/assets/svg/sorry/timely_payments.svg'),
          imgAlt: 'Make timely payments',
          content: 'Make timely payments: Ensure that you pay all your bills, loans, and credit card payments on time. Late payments can have a negative impact on your credit score. Consider setting up automatic payments or reminders to help you stay on track.'
        },
        {
          img: require('@/assets/svg/sorry/reduce_utilization.svg'),
          imgAlt: 'Reduce your credit utilization',
          content: 'Reduce your credit utilization: Aim to keep your credit card balances below 30% of your available credit limit. High credit utilization can adversely affect your credit score. Paying down existing balances can demonstrate responsible credit management.'
        },
        {
          img: require('@/assets/svg/sorry/build_credit.svg'),
          imgAlt: 'Build a positive credit history',
          content: 'Build a positive credit history: If you have limited credit history, consider applying for a secured credit card or becoming an authorized user on someone else\'s credit card account. Responsible use of these accounts can help establish a positive credit history.'
        },
        {
          // avoid new
          img: require('@/assets/svg/sorry/avoid_new.svg'),
          imgAlt: 'Avoid new credit applications',
          content: 'Avoid new credit applications: Multiple credit inquiries within a short period can lower your credit score. It\'s advisable to refrain from applying for new credit cards or loans while you work on improving your creditworthiness.'
        }

      ]
    }
  },

  // Computed
  computed: {
    firstName () {
      return this.$store.state.customer.first_name
    }
  },

  // Created
  created () {
    DataLayer.pushEvent('event', `spring_${this.eventPrefix}_sorry`)
  }
}
</script>

<style scoped lang="scss">
.sorry {
  @apply w-auto;

  @screen md {
    @apply w-675;
  }

  p {
    @apply mt-20 text-base;

    a {
      font-size: inherit;
    }
  }

  ol {
    li {
      @apply mt-20 pl-10;
    }
  }

  &-subheader {
    @apply mt-20 text-lg font-bold;
  }

  &-list-item {
    @apply flex my-20;

    &__icon {
      @apply w-50 h-50 m-10 mr-20;
    }
  }
}

</style>
